import axios from "axios";
import request from "../config/network/requestFinalCoursewareApiService";
import request2 from "../config/network/requestFinalAdminApiService";
import Config from "../config/app";

// 获取学科列表
export function querySubject_List(params) {
  return request({
    url: "course_middle/subject_list",
    method: "get",
    params,
  });
}
// 课程列表分页
export function queryCourseList(params) {
  return request({
    url: "course_middle/course_list",
    method: "get",
    params,
  });
}
// 课程列表添加
export function courseListAdd(params) {
  return request({
    url: "list/add",
    method: "post",
    data: params,
  });
}
// 课程列表编辑
export function courseListEdit(params) {
  return request({
    url: "list/edit",
    method: "post",
    data: params,
  });
}
// 生成课件分享秘钥
export function createShareAdd(params) {
  return request({
    url: "course_middle/create_share",
    method: "post",
    data: params,
  });
}
// 验证课件分享密码
export function checkSharePwd(url, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: `${Config.finalCoursewareApiService}${url}`,
      data: {
        ...data,
      },
    })
      .then((obj) => {
        if (obj.status === 200) {
          resolve(obj);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// export function checkSharePwd(params) {
//   return request({
//     url: "course_middle/check_share_pwd",
//     method: "post",
//     data: params,
//   });
// }
/* 批量发布更新(包括单个)
 * id 表示更新课时id集合，支持数组，逗号拼接字符串 例:"200,201"
 */
export function setUpdateSend({ course_id }) {
  return request({
    url: "courseware_packet/batch_packet",
    method: "post",
    data: { course_ids: course_id.toString() },
  });
}
// 单课时更新记录(查看课时)
export function queryUpdateRecordOne({ course_id }) {
  return request({
    url: `courseware_packet/log/only_course_packet/${course_id}`,
    method: "get",
  });
}
// 批量更新记录
export function queryUpdateRecordBatch({ ids, page }) {
  return request({
    url: `courseware_packet/log/course_packet_pri?page=${page}`,
    method: "get",
    data: { course_id: ids },
  });
}
// 批量更新记录详情
export function queryUpdateRecordBatchDetail({ id }) {
  return request({
    url: `courseware_packet/log/course_packet_desc/${id}`,
    method: "get",
  });
}
// 获取配置文件数据
export function queryConfig({ id }) {
  return request({
    url: `courseware_packet/${id}`,
    method: "get",
  });
}
// 获取主题文件数据
export function queryTheme({ theme_id }) {
  return request({
    url: `theme/${theme_id}`,
    method: "get",
  });
}
// 清除课程缓存
export function clearCourseCache({ course_id }) {
  return request({
    url: `courseware_packet/${course_id}/refresh_qiniu_cdn_cache`,
    method: "post",
  });
}
// 复制课程
export function copyCourse({ course_id, structure_id, ...params }) {
  return request2({
    url: `course/${course_id}/copy`,
    method: "post",
    data: { structure_id, ...params },
  });
}
// 获取用户权限
export function getPermissions({ roleId }) {
  return request2({
    url: `role/${roleId}`,
    method: "get",
  });
}

